<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <back-button></back-button>
                <v-spacer />
                {{ $t($route.meta.title) }}
                <v-spacer />
                <v-btn
                  @click="updateConfig"
                  :loading="loading"
                  class="btn-update"
                >
                  <v-icon>mdi-update</v-icon>
                  بروز رسانی
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field
                      v-model="key"
                      :error-messages="errors.key"
                      label="کلید"
                      required
                      disabled
                      readonly
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field
                      v-model="description"
                      :error-messages="errors.description"
                      label="توضیحات"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-select
                      v-model="type"
                      :items="types"
                      :error-messages="errors.type"
                      item-text="title"
                      item-value="value"
                      label="نوع"
                      outlined
                      dense
                      return-object
                    ></v-select>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex
                    xs12
                    sm12
                    md4
                    lg4
                    xl4
                    class="p-2"
                    v-if="type !== 'array'"
                  >
                    <v-text-field
                      v-model="value"
                      :error-messages="errors.value"
                      label="مقدار"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-col>
                    <v-card
                      v-if="type === 'array'"
                      elevation="0"
                      color="transparent"
                      class="mb-4"
                    >
                      <v-card
                        v-for="(x, i) in value"
                        :key="i"
                        outlined
                        class="mb-4"
                      >
                        <v-hover v-slot="{ hover }">
                          <v-card-title>
                            <v-chip outlined color="#009688">
                              متن {{ i + 1 }}
                            </v-chip>

                            <v-spacer />
                            <transition name="slide-x-transition" mode="out-in"
                              >-->
                              <v-btn
                                x-small
                                fab
                                elevation="0"
                                color="error"
                                @click="deleteConfig(x, i)"
                                v-if="hover"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </transition>
                          </v-card-title>
                        </v-hover>

                        <v-row align="center" class="ma-0 pt-3">
                          <v-col cols="12" lg="6" class="pt-0">
                            <label for="value">متن</label>
                            <v-text-field
                              v-model="x.value"
                              outlined
                              id="organName"
                            />
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card-actions class="pa-0 my-4">
                        <v-btn
                          block
                          :loading="loading"
                          large
                          class="rounded-t-md rounded-b-lg"
                          @click="newConfig"
                        >
                          <v-icon>mdi-plus</v-icon>
                          افزودن متن
                        </v-btn>
                      </v-card-actions>

                      <v-divider />
                    </v-card>

                    <v-card-title v-if="type !== 'array'">
                      <div class="w-100 text-center clickable">
                        <v-img
                          v-ripple
                          @click="pick"
                          id="avatar-block"
                          style="background: gray"
                          :aspect-ratio="1.5"
                          :src="value || '/media/avatar.webp'"
                        />

                        <input
                          id="avatar"
                          type="file"
                          class="d-none"
                          name="avatar"
                          @change="picked"
                        />

                        <div
                          class="w-100 text-right error--text pa-3 ml-auto"
                          v-if="
                            errors.picture != null && errors.picture.length > 0
                          "
                          v-text="errors.picture[0]"
                        />
                      </div>
                    </v-card-title>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      key: "",
      value: null,
      type: null,
      service: null,
      description: null,
      configsArray: [],
      picture: null,
      register: [],
      errors: {},
      loading: false,
      types: [
        { title: "متن", value: "text" },
        { title: "عکس", value: "image" },
        { title: "صحیح غلط", value: "boolean" },
        { title: "عدد", value: "number" },
        { title: "آرایه", value: "array" },
        { title: "آزاد", value: "any" },
      ],
    };
  },

  methods: {
    newConfig() {
      //
      this.value.push({
        id: this.value.length + 1,
        value: "",
      });
    },
    deleteConfig(x, i) {
      if (confirm("ویژگی حذف شود ؟")) {
        if (this.value[i].id) {
          this.value.splice(i, 1);
        }
      }
    },
    getConfig() {
      this.loading = true;
      this.requestApiGet(`config/${this.id}`).then(({ data }) => {
        this.key = data.key;

        this.description = data.description;
        this.type = data.type;
        this.service = data.service_id;
        this.loading = false;

        if (this.type === "array") {
          let txt = JSON.parse(data.val);
          this.value = txt;
        } else {
          this.value = data.val;
        }
      });
    },

    updateConfig() {
      this.loading = true;
      let formData = new FormData();
      if (this.type === "array") {
        formData.append("val", JSON.stringify(this.value));
      } else {
        formData.append("val", this.value);
      }

      //

      formData.append("service_id", this.service);
      formData.append("key", this.key);
      formData.append("type", this.type);
      formData.append("description", this.description);
      if (this.picture != null) formData.append("picture", this.picture);
      formData.append("_method", "PUT");

      this.requestApiPost(
        `config/${this.id}`,
        formData,
        this.configurationFile()
      )
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success("با موفقیت بروزرسانی شد");
          this.$router.push({ name: "configs" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        });
    },

    pick() {
      document.getElementById("avatar").click();
    },
    setEdited(x) {
      x.edited = true;
    },
    createRegister() {
      this.register.push({
        organName: "",
        type: null,
        date: "",
      });
    },

    picked(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files.length >= 1) {
        this.picture = files[0];
        let avatarBlock = document.getElementById("avatar-block");
        let fileReader = new FileReader();
        fileReader.onload = function (e) {
          let preview = avatarBlock.getElementsByClassName("v-image__image")[0];
          preview.style.backgroundImage = "url('" + this.result + "')";
          preview.style.display = "block";
        };
        fileReader.readAsDataURL(files[0]);
      }
    },
  },
  mounted() {
    this.getConfig();
  },
};
</script>
